<div class="auth-layout-container">
  <div class="auth-navbar">
    <div class="spacer"></div>

    <div class="nav-items-list">
      <div class="nav-item nav-item-language">
        <app-language-selector [alignDropdownToRight]="true"></app-language-selector>
      </div>
  
      <ng-container *ngIf="globals.user; else navNotLoggedIn">
        <div class="nav-item" (click)="logout()">
          <span class="fal fa-fw fa-sign-out"></span>
          <span class="m-right-5"></span>
          <span translate>{{eAuthMessages.LOG_OUT}}</span>
        </div>
      </ng-container>
  
      <ng-template #navNotLoggedIn>
        <div class="nav-item" (click)="collapseNavbar()" [routerLink]="'/auth/login'" routerLinkActive="active-link">
          <span class="fal fa-fw fa-sign-in" aria-hidden="true"></span>
          <span class="m-right-5"></span>
          <span translate>{{eAuthMessages.LOG_IN}}</span>
        </div>
  
        <!-- TODO: FDS-4403 - Enable once we decide to open registration -->
        <!-- <ng-container *ngIf="!router.url.includes('confirm-email')">
          <div class="nav-item" (click)="collapseNavbar()"  [routerLink]="'/auth/register'" routerLinkActive="active-link">
            <span class="fal fa-fw fa-user-plus" aria-hidden="true"></span>
            <span class="m-right-5"></span>
            <span translate>{{eAuthMessages.JOIN_FRANKLI}}</span>
          </div>
        </ng-container> -->
      </ng-template>
    </div>
  </div>

  <div class="auth-contents">
    <div class="auth-contents-inner">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
